 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import EBADFRONT from '@/components/ebadfront'
 import WBADWBNEWSLETTER from '@/components/WBad/WBNewsletter'
 import LOVE_1 from '@/components/love_1'
 import UNTITLED1 from '@/components/Untitled1'
 import UNTITLED12 from '@/components/Untitled12'
 import UNTITLED13 from '@/components/Untitled13'
 import UNTITLED14 from '@/components/Untitled14'
 import UNTITLED15 from '@/components/Untitled15'
 import UNTITLED16 from '@/components/Untitled16'
 import UNTITLED17 from '@/components/Untitled17'
 import UNTITLED18 from '@/components/Untitled18'
 import UNTITLED19 from '@/components/Untitled19'
 import UNTITLED110 from '@/components/Untitled110'
 import UNTITLED111 from '@/components/Untitled111'
 import UNTITLED112 from '@/components/Untitled112'
 import UNTITLED113 from '@/components/Untitled113'
 import UNTITLED114 from '@/components/Untitled114'
 import UNTITLED115 from '@/components/Untitled115'
 import UNTITLED116 from '@/components/Untitled116'
 import UNTITLED117 from '@/components/Untitled117'
 import UNTITLED118 from '@/components/Untitled118'
 import UNTITLED119 from '@/components/Untitled119'
 import UNTITLED120 from '@/components/Untitled120'
 import UNTITLED121 from '@/components/Untitled121'
 import UNTITLED122 from '@/components/Untitled122'
 import UNTITLED123 from '@/components/Untitled123'
 import UNTITLED124 from '@/components/Untitled124'
 import UNTITLED125 from '@/components/Untitled125'
 import UNTITLED126 from '@/components/Untitled126'
 import UNTITLED127 from '@/components/Untitled127'
 import UNTITLED128 from '@/components/Untitled128'
 import UNTITLED129 from '@/components/Untitled129'
 import UNTITLED130 from '@/components/Untitled130'
 import UNTITLED131 from '@/components/Untitled131'
 import UNTITLED132 from '@/components/Untitled132'
 import LOVE_2 from '@/components/love_2'
 import UNTITLED133 from '@/components/Untitled133'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/ebadfront",
 			"name" : "ebadfront",
 			"component" : EBADFRONT
 		},
 		{
 			"path" : "/WBad/WBNewsletter",
 			"name" : "WBad/WBNewsletter",
 			"component" : WBADWBNEWSLETTER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Untitled1",
 			"name" : "Untitled1",
 			"component" : UNTITLED1
 		},
 		{
 			"path" : "/Untitled12",
 			"name" : "Untitled12",
 			"component" : UNTITLED12
 		},
 		{
 			"path" : "/Untitled13",
 			"name" : "Untitled13",
 			"component" : UNTITLED13
 		},
 		{
 			"path" : "/Untitled14",
 			"name" : "Untitled14",
 			"component" : UNTITLED14
 		},
 		{
 			"path" : "/Untitled15",
 			"name" : "Untitled15",
 			"component" : UNTITLED15
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js